import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { Modal, Button } from 'react-bootstrap';

interface HelpButtonProps {
  className?: string;
  style?: React.CSSProperties;
}

export default function HelpButton({ className, style }: HelpButtonProps) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <button
        style={style}
        className={className}
        onClick={handleShow}
        aria-label="Help and Support"
      >
        <FontAwesomeIcon icon={faQuestion} />
      </button>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Help & Support</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">Need assistance? We're here to help!</p>
          <p className="mb-0">
            You can contact us at:{' '}
            <a href="mailto:support@marketnews.com" className="text-decoration-none">
              support@marketnews.com
            </a>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
